var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":"","justify":"center"}},[_c('v-progress-circular',{staticClass:"my-10",attrs:{"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }